<template>
  <div class="v-app pt-2 mt-2">
    <div class="content d-flex align-items-center justify-content-center" style="height: 100vh">
      <div class="text-center">
          <img src="../assets/page-not-found.png" alt="">
          <p class="ml-0">Sorry this page is not available at this time</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PageNotFound',
  methods: {
  }
}
</script>
